import React from "react";
import { Link } from "react-router-dom";
import "../styles/PageNotFound.css";

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <div className="error-content">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page Not Found</h2>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="home-button">
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;